export default __webpack_public_path__ + "static/media/point.42dc0caa.svg";